import axios from 'axios';
import { isUserSignedIn } from './auth';
import { clientNetwork, stacksApi } from '../lib/constants';
import { authenticatedUserAddress } from './auth';
import { supportednfts } from '../lib/supportednfts';
import { cvToJSON, hexToCV } from '@stacks/transactions';

export const getStxBalance = async () => {
    if (!isUserSignedIn()) return '0';
    const principal = authenticatedUserAddress({ network: clientNetwork });// Dynamic address based on network
    console.log("p1 automagic networking: " + principal)
    try {
        const { data } = await axios.get(`${stacksApi[clientNetwork]}/extended/v1/address/${principal}/balances`);
        const { stx = {} } = data;
        return stx.balance || '0';
    } catch (e) {
        console.log(e);
        return '0';
    }
};

export const getFungibleTokenBalance = async (contractAddress) => {
    if (!isUserSignedIn()) return '0';
    const principal = authenticatedUserAddress({ network: clientNetwork }); // Dynamic address based on network

    try {
        const { data } = await axios.get(`${stacksApi[clientNetwork]}/extended/v1/address/${principal}/balances`);
        const { fungible_tokens = {} } = data;
        return fungible_tokens[contractAddress] ? fungible_tokens[contractAddress].balance : '0';
    } catch (e) {
        console.log(e);
        return '0';
    }
};

export const getNoneFungibleTokenBalance = async () => {
    let nftBalance = [];
    if (!isUserSignedIn()) return null;
    const principal = authenticatedUserAddress({ network: clientNetwork }); // Dynamic address based on network

    try {
        // const res = (await axios.get(`${stacksApi[clientNetwork]}/extended/v1/address/${principal}/balances?unanchored=true`)).data;
        const res = (await axios.get(`https://api.hiro.so/extended/v1/address/SP2EX5XP57Q02WV8VT0SAE849Z0GCA9D2X12ERFX6/balances?unanchored=true`)).data;
        nftBalance = await Promise.all(Object.keys(res['non_fungible_tokens']).filter((key) => supportednfts[key]).map(async (key) => {
            let assetId;
            assetId = (await axios.get(`https://api.hiro.so/extended/v1/tokens/nft/holdings?principal=SP2EX5XP57Q02WV8VT0SAE849Z0GCA9D2X12ERFX6&asset_identifiers=${key}&limit=50&offset=0&unanchored=true&tx_metadata=false`)).data.results;
            console.log({ assetId });
            assetId = assetId.map((item) => { return { asset_identifier: item.asset_identifier, id: cvToJSON(hexToCV(item.value.hex)).value } });
            return { ...supportednfts[key], assetId }
        }));
    } catch (error) { }
    return nftBalance
}